module.exports = "<div class=\"tabs__content\" v-bind:class=\"activeClass\">\n  <slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/tabs/tab-content/index.html
// module id = 0exw
// module chunks = 1